var $ = require('jquery');
var _find = require('lodash/find');
var _difference = require('lodash/difference');
var Modernizr = require('../../vendors/modernizr.min');
var WS = require('../../scripts/ws');
require('jquery-match-height');

$(function () {
    let $carousel = $(".ws-carousel:not(.lazyload)");
    let carouselSelector = ".ws-carousel";
    let carouselItemSelector = ".ws-carousel__item";

    // Carousel Themes
    let carouselHeroImageClass     = "ws-carousel--theme_hero-image";
    let carouselHeroSpotlightClass = "ws-carousel--theme_hero-spotlight";
    let carouselFilmStripClass     = "ws-carousel--theme_film-strip";
    let carouselTestimonialsClass  = "ws-carousel--theme_testimonials";
    let carouselAgentDetailClass   = "ws-carousel--theme_agent-detail";

    let breakpointMappings = {
        xs: 374,
        sm: 767,
        md: 991,
        lg: 1400
    };

    let listSelector = '.slick-list';
    let trackSelector = '.slick-track';
    let isTouchDevice = Modernizr.browsertouch;
    let isEnterOrSpace;
    let carouselTriggeredManually = false;

    // Logic or checks to perform prior to carousel initialization
    function carouselPreInit($targetCarousel) {
        let itemCount = $targetCarousel.children(carouselItemSelector).length;

        if ($targetCarousel.data('disabled') === true ||
            (itemCount < 2 && !$targetCarousel.hasClass(carouselFilmStripClass)) ||
            (itemCount < 1 && $targetCarousel.hasClass(carouselFilmStripClass))) {
            return;
        }

        carouselInit($targetCarousel);

    }

    // Initialize carousel instance based on theme ($target = carousel element)
    var carouselInit = function CarouselInit($target) {
        // autoplay defaults to true, autoplayMobile defaults to false
        var autoplay = $target.data('autoplay') === undefined ? true : $target.data('autoplay');
        var autoplayMobile = !!$target.data('autoplayMobile');
        var disableBreakpoint = $target.data('disableAtBreakpoint');
        var centerPadding = $target.data('centerPadding') === undefined ? '35px' : $target.data('centerPadding');
        var variableWidth = $target.data('variableWidth') === undefined ? true : $target.data('variableWidth');
        var arrows = $target.data('arrows') === undefined ? false : $target.data('arrows');
        var asNavFor = $target.data('asNavFor') === undefined ? null : $target.data('asNavFor');

        // if the match height plugin is being used to keep heights of elements in
        // the carousel consistent, then as slick clones elements we need to keep
        // the match height element groups updated accordingly
        var matchHeightSelectorString = $target.data('ws-mh');

        if (matchHeightSelectorString) {
            var selectors = matchHeightSelectorString.split('|'),
                groupIndexes = [];

            if (!$target.hasClass(carouselFilmStripClass)) {
                $target.on('setPosition', function (event, slick) {
                    matchCarouselItemHeights($target, groupIndexes, selectors);
                });
            }
        }

        if ($target.hasClass(carouselHeroImageClass)) {
            $target.slick({
                arrows: false,
                asNavFor: asNavFor,
                autoplay: !WS.isExperienceEditor(),
                autoplaySpeed: 7000,
                dots: false,
                edgeFriction: 0,
                infinite: false,
                mobileFirst: true,
                speed: 500,
                waitForAnimate: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            arrows: true,
                            speed: 700
                        }
                    }
                ]
            });

            // override the default slick autoPlayIterator to rewind to the first slide after moving past the last slide. this
            // edit is based on version 1.6.0 of slick slider. may need to be updated if the plugin version is changed.
            var slick = $target[0].slick;
            slick.autoPlayIterator = function () {

                var _ = slick, // originally was var _ = this, but this was being set to window in the edited code
                    slideTo = _.currentSlide + _.options.slidesToScroll;

                if (!_.paused && !_.interrupted && !_.focussed) {

                    if (_.options.infinite === false) {

                        if (_.direction === 1 && (_.currentSlide + 1) === (_.slideCount - 1)) {
                            _.direction = 0;
                        }

                        else if (_.direction === 0) {

                            /* begin edited code */

                            slideTo = 0;
                            _.direction = 1;

                            /* end edited code */

                        }

                    }

                    _.slideHandler(slideTo);

                }

            };

            setSwipeSyncEvents($target, $(asNavFor));

            $target.on('click', function () {
                $target
                    .slick('slickSetOption', 'autoplay', false)
                    .slick('slickPause');
            });

            if (WS.isExperienceEditor()) {
                $target.on('afterChange', function (event, slick, currentSlide) {
                    WS.resetChromes();
                });
            }
        } else if ($target.hasClass(carouselHeroSpotlightClass)) {
            var $asNavFor = $(asNavFor);

            $target.slick({
                arrows: false,
                asNavFor: asNavFor,
                dots: true,
                dotsClass: 'ws-carousel__navigation ws-carousel__navigation--theme_light',
                customPaging: function (slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text('Slide ' + (i + 1));
                },
                edgeFriction: 0,
                infinite: false,
                mobileFirst: true,
                speed: 500,
                variableWidth: true,
                waitForAnimate: false,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            speed: 700
                        }
                    }
                ]
            });

            setSwipeSyncEvents($target, $asNavFor);

            $target.on('click', function () {
                $asNavFor
                    .slick('slickSetOption', 'autoplay', false)
                    .slick('slickPause');;
            });

            $target.on('mouseenter.slick', function () {
                $asNavFor.slick('slickPause');
            });

            $target.on('mouseleave.slick', function () {
                if ($asNavFor.slick('slickGetOption', 'autoplay')) {
                    $asNavFor.slick('slickPlay');
                }
            });

            // Handler to scroll carousel nav dots into view on focus via keyboard
            var $navDotButtons = $target.find('.ws-carousel__navigation button');
            if ($navDotButtons.length) {
                $navDotButtons.on('keydown', function (event) {
                    const key = event.which || event.keyCode;

                    if (key == 9) { // TAB key
                        event.target.scrollIntoView(false);
                    }
                });
            }
        } else if ($target.hasClass(carouselFilmStripClass)) {
            // Need different breakpoints based on:
            //      - viewport < 768px || viewport >= 768px
            //      - number of active cards to show (n)
            //      - carousel container padding
            // Breakpoint formula:
            //      padding + n(10px margins) + n(272px widths) + 5px peek margin + 40px interactive area +/- 17px scrollbar
            let isArticlePage = $target.hasClass('ws-carousel--article');
            let responsiveSettings, responsiveMobileSettings;

            if (isArticlePage) {
                responsiveSettings = [
                    {
                        breakpoint: 1462,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 636,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ];
            }
            else {
                responsiveSettings = [
                    {
                        breakpoint: 1524,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                    {
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    },
                    {
                        breakpoint: 958,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 651,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ];
            }

            if (isArticlePage) {
                responsiveMobileSettings = [
                    {
                        breakpoint: 1462,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 636,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ];
            }
            else {
                responsiveMobileSettings = [
                    {
                        breakpoint: 1490,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 5
                        }
                    },
                    {
                        breakpoint: 1206,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    },
                    {
                        breakpoint: 924,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 617,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }
                ];
            }

            if (breakpointMappings.hasOwnProperty(disableBreakpoint)) {
                let breakpoint = breakpointMappings[disableBreakpoint];
                let breakpointSetting = _find(responsiveSettings, function (setting) {
                    return setting.breakpoint === breakpoint;
                });

                if (typeof breakpointSetting === 'undefined' || !breakpointSetting) {
                    responsiveSettings.push({
                        breakpoint: breakpoint,
                        settings: 'unslick'
                    });
                } else {
                    breakpointSetting.settings = 'unslick';
                }
            }

            /* START Slick Event Listener Setup, which must be bound BEFORE initialization */
            $target.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                // Check if navigating to the last set of cards
                if (slick.slideCount <= (nextSlide + slick.options.slidesToScroll)) {
                    // If total number of cards not evenly divisible by viewport's slidesToShow,
                    // Then "Peek" card will not appear to navigate back.
                    // Must manually set slidesToShow based on # extra slides.
                    let extraSlides = slick.slideCount % slick.options.slidesToShow;
                    if (extraSlides) {
                        $target.slick('slickSetOption', 'slidesToShow', extraSlides);
                    }
                } else if (slick.options.slidesToShow != slick.options.slidesToScroll) {
                    // If these don't match, they need to be restored to normal viewport settings after leaving last slide
                    // NOTE: These will automatically revert if viewport is resized
                    $target.slick('slickSetOption', 'slidesToShow', slick.options.slidesToScroll);
                }
            });

            if (!isTouchDevice) {
                $target.on('afterChange', function (event, slick, currentSlide) {
                    // Check if the slide change was from ENTER or SPACE to retain focus styling.
                    if (isEnterOrSpace) {
                        $('body').removeClass('ws-click');

                        // When ends of carousel reached via keyboard navigation, return focus to opposite arrow button
                        if (slick.$nextArrow.hasClass('slick-disabled')) {
                            slick.$prevArrow.focus();
                        }
                        else if (slick.$prevArrow.hasClass('slick-disabled')) {
                            slick.$nextArrow.focus();
                        }

                        isEnterOrSpace = false;
                    }
                });
            }

            $target.on('setPosition', function () {
                if (!isTouchDevice) {
                    // Padding between Page Edge and Content is set dynamically.
                    // Need this horizontal distance to move the carousel arrows onto page edges.
                    // Update arrow positions when carousel (i.e. viewport) is resized.
                    let paddingValue = $('.ws-section__item.ws-section__item--overflow_hidden').css('padding-right');

                    $('.ws-carousel--theme_film-strip .slick-next').css('right', '-' + paddingValue);
                    $('.ws-carousel--theme_film-strip .slick-prev').css('left', '-' + paddingValue);
                }

                if (matchHeightSelectorString) {
                    matchCarouselItemHeights($target, groupIndexes, selectors);
                }
            });
            /* END Slick Event Listener Setup */

            // Only show full carousel content immediately prior to initialization.
            // Avoids long vertical display issues, esp. for multiple film strips & EE.
            $target.css({
                'height': 'auto',
                'overflow-y': 'visible'
            });

            $target.slick({
                arrows: (!isTouchDevice),
                autoplay: false,
                dots: false,
                dotsClass: 'ws-carousel__navigation',
                customPaging: function (slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text('Slide ' + (i + 1));
                },
                infinite: false,
                mobileFirst: true,
                variableWidth: true,
                responsive: (Modernizr.mq('(max-width: 767px)') ? responsiveMobileSettings : responsiveSettings),
                slidesToScroll: 1,
                slidesToShow: 1,
                touchMove: isTouchDevice,
                waitForAnimate: false
            });

            if (!isTouchDevice) {
                // Can only be added AFTER slick initialization
                $target.find('.slick-arrow').addClass('ws-carousel__slick-arrow--theme_film-strip');

                // Set flag for ENTER or SPACE keypresses on ARROW and DOT buttons
                $('.ws-carousel__slick-arrow--theme_film-strip, .ws-carousel__navigation button').on('keydown', function (event) {
                    const key = event.which || event.keyCode;

                    if (key == 13 || key == 32) { // SPACE or ENTER key
                        isEnterOrSpace = true;
                    } else {
                        isEnterOrSpace = false;
                    }
                });
            }
        } else if ($target.hasClass(carouselTestimonialsClass)) {
            let responsiveSettings, responsiveMobileSettings;
            
            responsiveSettings = [
                {
                    breakpoint: 1425,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 965,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 610,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ];
            
            responsiveMobileSettings = [
                {
                    breakpoint: 1410,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 594,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ];

            if (breakpointMappings.hasOwnProperty(disableBreakpoint)) {
                let breakpoint = breakpointMappings[disableBreakpoint];
                let breakpointSetting = _find(responsiveSettings, function (setting) {
                    return setting.breakpoint === breakpoint;
                });

                if (typeof breakpointSetting === 'undefined' || !breakpointSetting) {
                    responsiveSettings.push({
                        breakpoint: breakpoint,
                        settings: 'unslick'
                    });
                } else {
                    breakpointSetting.settings = 'unslick';
                }
            }

            /* START Slick Event Listener Setup, which must be bound BEFORE initialization */
            $target.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                // Check if navigating to the last set of cards
                if (slick.slideCount <= (nextSlide + slick.options.slidesToScroll)) {
                    // If total number of cards not evenly divisible by viewport's slidesToShow,
                    // Then "Peek" card will not appear to navigate back.
                    // Must manually set slidesToShow based on # extra slides.
                    let extraSlides = slick.slideCount % slick.options.slidesToShow;
                    if (extraSlides) {
                        $target.slick('slickSetOption', 'slidesToShow', extraSlides);
                    }
                } else if (slick.options.slidesToShow != slick.options.slidesToScroll) {
                    // If these don't match, they need to be restored to normal viewport settings after leaving last slide
                    // NOTE: These will automatically revert if viewport is resized
                    $target.slick('slickSetOption', 'slidesToShow', slick.options.slidesToScroll);
                }
            });

            if (!isTouchDevice) {
                $target.on('afterChange', function (event, slick, currentSlide) {
                    // Check if the slide change was from ENTER or SPACE to retain focus styling.
                    if (isEnterOrSpace) {
                        $('body').removeClass('ws-click');

                        // When ends of carousel reached via keyboard navigation, return focus to opposite arrow button
                        if (slick.$nextArrow.hasClass('slick-disabled')) {
                            slick.$prevArrow.focus();
                        }
                        else if (slick.$prevArrow.hasClass('slick-disabled')) {
                            slick.$nextArrow.focus();
                        }

                        isEnterOrSpace = false;
                    }
                });
            }

            $target.on('setPosition', function () {
                if (!isTouchDevice) {
                    // Padding between Page Edge and Content is set dynamically.
                    // Need this horizontal distance to move the carousel arrows onto page edges.
                    // Update arrow positions when carousel (i.e. viewport) is resized.
                    let paddingValue = $('.ws-section__item.ws-section__item--overflow_hidden').css('padding-right');

                    $('.ws-carousel--theme_testimonials .slick-next').css('right', '-' + paddingValue);
                    $('.ws-carousel--theme_testimonials .slick-prev').css('left', '-' + paddingValue);
                }

                if (matchHeightSelectorString) {
                    matchCarouselItemHeights($target, groupIndexes, selectors);
                }
            });
            /* END Slick Event Listener Setup */

            // Only show full carousel content immediately prior to initialization.
            // Avoids long vertical display issues, esp. for multiple film strips & EE.
            $target.css({
                'height': 'auto',
                'overflow-y': 'visible'
            });

            $target.slick({
                arrows: (!isTouchDevice),
                autoplay: false,
                dots: false,
                dotsClass: 'ws-carousel__navigation',
                customPaging: function (slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text('Slide ' + (i + 1));
                },
                infinite: false,
                mobileFirst: true,
                variableWidth: true,
                responsive: (Modernizr.mq('(max-width: 767px)') ? responsiveMobileSettings : responsiveSettings),
                slidesToScroll: 1,
                slidesToShow: 1,
                touchMove: isTouchDevice,
                waitForAnimate: false
            });

            if (!isTouchDevice) {
                // Can only be added AFTER slick initialization
                $target.find('.slick-arrow').addClass('ws-carousel__slick-arrow--theme_testimonials');

                // Set flag for ENTER or SPACE keypresses on ARROW and DOT buttons
                $('.ws-carousel__slick-arrow--theme_testimonials, .ws-carousel__navigation button').on('keydown', function (event) {
                    const key = event.which || event.keyCode;

                    if (key == 13 || key == 32) { // SPACE or ENTER key
                        isEnterOrSpace = true;
                    } else {
                        isEnterOrSpace = false;
                    }
                });
            }
        } else {
            var responsiveSettings = [
                {
                    breakpoint: breakpointMappings['sm'],
                    settings: {
                        autoplay: autoplay,
                        variableWidth: variableWidth
                    }
                }
            ];

            if (breakpointMappings.hasOwnProperty(disableBreakpoint)) {
                var breakpoint = breakpointMappings[disableBreakpoint];
                var breakpointSetting = _find(responsiveSettings, function (setting) {
                    return setting.breakpoint === breakpoint;
                });

                if (typeof breakpointSetting === 'undefined' || !breakpointSetting) {
                    responsiveSettings.push({
                        breakpoint: breakpoint,
                        settings: 'unslick'
                    });
                } else {
                    breakpointSetting.settings = 'unslick';
                }
            }

            /* Slick Event Listener Setup, which must be bound BEFORE initialization */
            if ($target.hasClass(carouselAgentDetailClass)) {
                // Screen readers should announce Agent Detail carousel slides only on manual navigation
                // After user selects slide, update hidden aria-live element with callout card content 
                $target.on('afterChange', function (event, slick, currentSlide) {
                    if (carouselTriggeredManually) {
                        var slideHeading = $(slick.$slides[currentSlide]).find('.ws-heading').html();
                        var slideContent = $(slick.$slides[currentSlide]).find('.ws-content').html();
                        $('.ws-carousel__screen-reader-content').html('<p>' + slideHeading + '...' + '</p>' + slideContent);

                        carouselTriggeredManually = false;
                    }
                });
            }

            $target.slick({
                arrows: arrows,
                asNavFor: asNavFor,
                autoplay: autoplayMobile,
                centerMode: true,
                centerPadding: centerPadding,
                dots: true,
                dotsClass: 'ws-carousel__navigation',
                customPaging: function (slider, i) {
                    return $('<button type="button" data-role="none" role="button" tabindex="0" />').text('Slide ' + (i + 1));
                },
                mobileFirst: true,
                variableWidth: false,
                responsive: responsiveSettings,
                waitForAnimate: false
            });

            matchHeight($target);

            if ($target.hasClass(carouselAgentDetailClass)) {
                // For consistent behavior, select any element user could interact with to manually change carousel
                var $carouselNavElements = $('.ws-carousel--theme_agent-detail .ws-carousel__item')
                    .add($target.get(0).slick.$dots.find('button'));

                $carouselNavElements.on('click', function () {
                    // Only an inactive "peek" card or navigation dot should trigger carousel
                    // Can ignore interactions with active card, as this will cause duplicate screen readings
                    if (
                        $(this).is('.ws-carousel__item:not(.slick-active)') ||
                        $(this).is('button')
                    ) {
                        carouselTriggeredManually = true;
                    }
                });
            }

            // Handler to scroll carousel elements dots into view on focus via keyboard
            var $navElements = $target.find('.ws-carousel__navigation button, button.slick-arrow');
            if ($navElements.length) {
                $navElements.on('keydown', function (event) {
                    const key = event.which || event.keyCode;

                    if (key == 9) { // TAB key
                        event.target.scrollIntoView(false);
                    }
                });
            }
        }
    }

    function matchCarouselItemHeights($target, groupIndexes, selectors) {
        if (groupIndexes.length === 0) {
            // the ws-mh-group-indexes data attribute is set when match height
            // gets initialized. since the carousel might be created before then,
            // we wait until the setPosition callback fires to try to read the
            // value. once things have been successfully initialized, we stop
            // parsing the DOM element and use the previously read value
            var matchHeightGroupString = $target.data('ws-mh-group-indexes');

            if (matchHeightGroupString) {
                groupIndexes = matchHeightGroupString.split('|');
            }
        }

        if (selectors.length === groupIndexes.length) {
            for (var i = 0; i < selectors.length; ++i) {
                var $selectedElements = $target.find(selectors[i].trim());
                var matchHeightGroup = $.fn.matchHeight._groups[groupIndexes[i]];
                if (matchHeightGroup && matchHeightGroup.elements) {
                    var $diff = _difference($selectedElements, matchHeightGroup.elements);

                    if ($diff.length > 0) {
                        matchHeightGroup.elements = $selectedElements;
                        matchHeight($target);
                    }
                }
            }
        }
    }

    function matchHeight($target) {
        var $matchHeightTarget = $target.find('.ws-mh-target');
        if ($matchHeightTarget.length && $matchHeightTarget.matchHeight) {
            $matchHeightTarget.matchHeight._update();
        }
    }

    function setSwipeSyncEvents($target, $asNavFor) {
        var $track,
            $otherTrack,
            startingX,
            otherStartingX,
            isActive = false,
            isSlideChanging = false;

        $target.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            isSlideChanging = currentSlide !== nextSlide;
        });

        $target.on('touchstart.slick mousedown.slick', listSelector, function () {
            isActive = true;

            if (!$track || !$.contains(document, $track[0])) {
                $track = $target.find(trackSelector);
            }

            if (!$otherTrack || !$.contains(document, $otherTrack[0])) {
                $otherTrack = $asNavFor.find(trackSelector);
            }

            startingX = getTranslateX($track);
            otherStartingX = getTranslateX($otherTrack);
        });

        $target.on('touchmove.slick mousemove.slick', listSelector, function () {
            if ($otherTrack && isActive) {
                var deltaX = getTranslateX($track) - startingX;
                $otherTrack.css({ 'transform': 'translate3d(' + (otherStartingX + deltaX) + 'px, 0, 0)' });
            }
        });

        $target.on('touchend.slick mouseup.slick touchcancel.slick mouseleave.slick', listSelector, function () {
            if ($otherTrack && isActive && !isSlideChanging) {
                $otherTrack.css({ 'transform': 'translate3d(' + otherStartingX + 'px, 0, 0)' });
            }

            isActive = false;
        });
    }

    function getTranslateX($element) {
        var matrix = $element.css('transform').replace(/[^0-9\-.,]/g, '').split(',');
        return parseInt(matrix[12] || matrix[4]);
    }

    // Begin initializing immediate carousels on page
    $carousel.each(function () {
        carouselPreInit($(this));
    });

    // Begin initializing lazy loaded carousels
    $(document).on('lazyloaded', carouselSelector, function (event) {
        if (event.currentTarget === event.target) {
            carouselPreInit($(event.target));
        }
    });

    // Prevent "peek" film strip cards from acting as links
    $('.ws-carousel--theme_film-strip .ws-carousel__item').on('click', function (event) {
        if (!$(this).hasClass('slick-active')) {
            event.preventDefault();
        }
    });

    // Prevent "peek" agent callout links from acting as links
    $('.ws-carousel--theme_agent-detail .ws-carousel__item .ws-icon-link').on('click', function (event) {
        if (!$(this).parents(carouselItemSelector).hasClass('slick-active')) {
            event.preventDefault();
        }
    });

    // Handle carousel navigation via card clicks.
    // Lazy loading will postpone needed carousel content from being created via slick initialization,
    // so this event handler needs to be delegated to containing section.
    $(".ws-section--carousel[class*='lazyload']").on('click', '[data-slick-index]', function () {
        var $this = $(this);
        var $thisSlick = $this.parents(carouselSelector).slick('getSlick');
        var slickIndex = $this.data('slickIndex');
        var $prevSlide = $this.siblings('[data-slick-index="' + (slickIndex - 1) + '"]');
        var $nextSlide = $this.siblings('[data-slick-index="' + (slickIndex + 1) + '"]');

        var isFilmStrip = $this.parents(carouselSelector).hasClass(carouselFilmStripClass);
        var isActiveCard = $this.hasClass('slick-active');

        if ($prevSlide.length && $prevSlide.hasClass('slick-active')) {
            if (!isFilmStrip || (isFilmStrip && !isActiveCard)) {
                $thisSlick.slickNext();
            }
        } else if ($nextSlide.length && $nextSlide.hasClass('slick-active')) {
            if (!isFilmStrip || (isFilmStrip && !isActiveCard)) {
                $thisSlick.slickPrev();
            }
        }
    });
});
